import { useCallback } from 'react';

import { useMultiFactorAuthenticationPopup } from './useMultiFactorAuthenticationPopup';

export const useRequestMultiFactorAuthentication = () => {
    const multiFactorAuthenticationPopup = useMultiFactorAuthenticationPopup();

    return useCallback(async ({ onCancel, onSuccess, ...rest }) => {
        // wait for a token from ReCaptcha component within the form
        return await new Promise((resolve, reject) => {
            multiFactorAuthenticationPopup({
                onCancel: () => {
                    onCancel();
                    reject();
                },
                onSuccess: () => {
                    onSuccess();
                    resolve();
                },
                resendHandler: () => {
                    onSuccess();
                    resolve();
                },
                ...rest
            });
        });
    }, [multiFactorAuthenticationPopup]);
};
